(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('me-js');

  function reveler(racine) {
    var els = (racine || document).querySelectorAll('.me-rise, .me-fil');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('vu'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vu'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      if (el.classList.contains('me-rise')) el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
      io.observe(el);
      setTimeout(function () { el.classList.add('vu'); }, 3000);
    });
  }

  function carrousels(racine) {
    (racine || document).querySelectorAll('[data-me-carrousel]').forEach(function (card) {
      if (card.dataset.meInit) return;
      card.dataset.meInit = '1';
      var slots = card.querySelectorAll('.me-ph__s');
      var dots  = card.querySelectorAll('.me-pts i');
      var nus   = card.querySelectorAll('.me-nu');
      var nom   = card.querySelector('.me-nom');
      if (slots.length < 2) return;
      var i = 0, timer = null;
      function show(n) {
        i = (n + slots.length) % slots.length;
        slots.forEach(function (el, k) { el.classList.toggle('on', k === i); });
        dots.forEach(function (el, k) { el.classList.toggle('on', k === i); });
        nus.forEach(function (el, k) { el.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        if (nom && nus[i]) nom.textContent = nus[i].getAttribute('aria-label');
      }
      nus.forEach(function (b, k) {
        b.addEventListener('click', function (e) { e.preventDefault(); stop(); show(k); });
        b.addEventListener('mouseenter', function () { stop(); show(k); });
      });
      function start() { if (!timer && !reduce) timer = setInterval(function () { show(i + 1); }, 2000); }
      function stop() { clearInterval(timer); timer = null; }
      show(0);
      card.addEventListener('mouseenter', start);
      card.addEventListener('mouseleave', function () { stop(); show(0); });
    });
  }

  function init(racine) { reveler(racine); carrousels(racine); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
